import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  defaultAbateParams,
  normalizeTipoAno,
  RelatorioTransacoesPage,
} from '../../-RelatorioTransacoesPage';

export const Route = createFileRoute('/_authenticated/relatorio-transacoes/$tipo/$ano/')({
  beforeLoad: ({ params }) => {
    const { tipo, ano } = normalizeTipoAno(params);
    if (tipo === 'abate') {
      return redirect({
        to: '/relatorio-transacoes/$tipo/$ano/$mes',
        params: { ...defaultAbateParams(), ano },
        replace: true,
      });
    }
    if (tipo !== params.tipo || ano !== params.ano) {
      return redirect({
        to: '/relatorio-transacoes/$tipo/$ano',
        params: { tipo, ano },
        replace: true,
      });
    }
  },
  component: RelatorioTransacoesAnoRoute,
});

function RelatorioTransacoesAnoRoute() {
  const { tipo, ano } = Route.useParams();
  return (
    <RelatorioTransacoesPage
      tipo={tipo}
      ano={ano}
    />
  );
}
